const SEPARATOR = '-';
const resolveId = ({ rawVal = '' }: any) => {
  const id = rawVal.split(SEPARATOR).join('');

  return id;
};

export default resolveId;
